import React from "react";
import { Coins, Download, TrendingUp, WalletCards } from "lucide-react";
import { AdminPageHeader, Badge, Button, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const histories = [
  { member: "김민준", reason: "구매 적립", point: "+23,500P", date: "2026.05.03" },
  { member: "이서연", reason: "상품 구매 사용", point: "-12,000P", date: "2026.05.02" },
  { member: "박지훈", reason: "리뷰 보상", point: "+1,000P", date: "2026.05.01" },
];

export default function AdminPoints() {
  return (
    <Page>
      <AdminPageHeader title="포인트 관리" description="회원 포인트 적립, 사용, 소멸 예정 금액을 관리합니다." />
      <StatGrid>
        <StatCard><WalletCards size={24} /><span>총 보유 포인트</span><strong>8.2M P</strong></StatCard>
        <StatCard><TrendingUp size={24} /><span>이번 달 적립</span><strong>642K P</strong></StatCard>
        <StatCard><Coins size={24} /><span>소멸 예정</span><strong>91K P</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>포인트 내역</h2><Button><Download size={16} /> CSV</Button></header>
        {histories.map((item) => (
          <ListRow key={`${item.member}-${item.date}`} $columns="1fr 130px 120px 110px">
            <div><strong>{item.member}</strong><span>{item.reason}</span></div>
            <Badge $bg={item.point.startsWith("+") ? "#ecfdf5" : "#fff7ed"} $fg={item.point.startsWith("+") ? "#059669" : "#ea580c"}>{item.point}</Badge>
            <span>{item.date}</span>
            <Button>상세</Button>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
